import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import { growl } from "/WebInterface/new-ui/modules/toast.js";
import Tooltip from "/WebInterface/new-ui/modules/tooltip/tooltip.js";
import MediaBar from "/WebInterface/new-ui/modules/quick-view-slider/media-bar/media-bar.js";
import {
  AudioPreview,
  ImagePreview,
  VideoPreview,
} from "/WebInterface/new-ui/modules/quick-view-slider/media.js";
import {
  mediaTypes,
  videoExtensionsSlideshow,
  audioExtensionsSlideshow,
} from "/WebInterface/new-ui/assets/js/constants.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import userActions from "/WebInterface/new-ui/assets/js/app/user-actions.js";
import templates from "./template.js";
import store from "/WebInterface/new-ui/store/index.js";

let idCounter = 0;

export default class Slideshow {
  constructor(slides = [], delay = 3000) {
    this.slides = slides;
    this.currentSlide = 0;
    this.slideDelay = delay;
    this.slideInterval = null;
    this.slidesLength = this.slides.length;

    this.id = `slideShow-${++idCounter}`;
    this.media = null;
    this.filesAddedToBasket = new Set([]);
    this.tooltip = new Tooltip();
  }

  init = () => {
    const existingSlide = _$(`#${this.id}`);
    if (!existingSlide.el()) {
      this.createMainSlider();
    }
  };

  createMainSlider = () => {
    const mainSlider = _$("<div>").addClass("slideshow");
    mainSlider.el().id = this.id;
    _$("body").append(mainSlider.el());

    const slideShowTemplate = templates.slideShowTemplate();
    mainSlider.html(slideShowTemplate);

    const slideshowClose = _$(`#${this.id} .slideshow-close`);
    slideshowClose.on("click", () => {
      this.closeSlider();
    });
  };

  getMediaInfo = (sliderInfo) => {
    const mediaInfo = sliderInfo?.mediaInfo;
    if (mediaInfo) return mediaInfo;

    const fileExtension = utils.getFileExtension(sliderInfo);
    const canPlayVideo = document
      .createElement("video")
      ?.canPlayType(`video/${fileExtension}`);
    const canPlayAudio = document
      .createElement("audio")
      ?.canPlayType(`audio/${fileExtension}`);

    const getMediaInfoObj = (type, extension) => {
      return {
        type: type,
        mimeType: `${type}/${extension}`,
      };
    };

    if (canPlayVideo || videoExtensionsSlideshow.includes(fileExtension))
      return getMediaInfoObj("video", fileExtension);
    if (canPlayAudio || audioExtensionsSlideshow.includes(fileExtension))
      return getMediaInfoObj("audio", fileExtension);
    return getMediaInfoObj("image", fileExtension);
  };

  displayFile = (sliderInfo) => {
    const { name } = (this.sliderInfo = sliderInfo);

    const content = _$(`#${this.id} .slideshow-player-section`);
    content.html("");

    const slideShowPageTotal = _$(`#${this.id} .slideshow-pageTotal`);
    slideShowPageTotal.html(`${this.currentSlide + 1} / ${this.slidesLength}`);

    const previewSection = _$(`#${this.id} .slideshow-footer .preview`).find(
      ".media-preview"
    );
    previewSection.sel().forEach((element, index) => {
      element.classList.remove("selected");
      if (index === this.currentSlide) {
        element.classList.add("selected");
      }
    });

    const createControlBar = (mediaType) => {
      this.createControlBar(mediaType);
      this.controlBarEvents();
    };

    const stopSlideshow = () => {
      this.stopSlideshow();
    };

    const mediaInfo = this.getMediaInfo(sliderInfo);
    this.mediaPlayed = false;

    switch (mediaInfo.type) {
      case mediaTypes.IMAGE:
        _$("#videoPlayer").remove();

        const imagePreview = new ImagePreview({
          previewInfo: sliderInfo,
          parent: content.el(),
        });

        const img = imagePreview.image;
        this.media = img;

        createControlBar(mediaInfo.type);

        _$("#zoomIn").on("click", () => {
          imagePreview.zoomIn(img);
          stopSlideshow();
        });

        _$("#zoomOut").on("click", () => {
          imagePreview.zoomOut(img);
          stopSlideshow();
        });

        _$("#leftRotate").on("click", () => {
          imagePreview.rotateImage("left");
          stopSlideshow();
        });

        _$("#rightRotate").on("click", () => {
          imagePreview.rotateImage("right");
          stopSlideshow();
        });
        break;

      case mediaTypes.VIDEO:
        _$("#videoPlayer").remove();

        const videoPreview = new VideoPreview({
          previewInfo: sliderInfo,
          parent: content.el(),
          controls: true,
        });
        const video = videoPreview.videoElement;
        this.media = video;

        _$(video).on("play", () => {
          this.mediaPlayed = true;
        });

        createControlBar(mediaInfo.type);
        break;

      case mediaTypes.AUDIO:
        _$("#videoPlayer").remove();

        const audioPreview = new AudioPreview({
          previewInfo: sliderInfo,
          parent: content.el(),
        });
        const audio = audioPreview.audio;
        const waveContainer = audioPreview.waveContainer;
        _$(waveContainer).addClass("wave-div");

        this.media = audio;

        createControlBar(mediaInfo.type);

        const mediaBarAudio = new MediaBar(audio, audio);
        mediaBarAudio.init();

        _$(audio).on("play", () => {
          this.mediaPlayed = true;
        });

        _$(audio).on("ended", () => {
          this.nextSlide();
        });
        break;

      default:
        _$("#videoPlayer").remove();

        const imagePreviewNew = new ImagePreview({
          previewInfo: sliderInfo,
          parent: content.el(),
        });

        const imgNew = imagePreviewNew.image;
        this.media = imgNew;

        createControlBar("image");

        _$("#zoomIn").on("click", () => {
          imagePreviewNew.zoomIn(imgNew);
          stopSlideshow();
        });

        _$("#zoomOut").on("click", () => {
          imagePreviewNew.zoomOut(imgNew);
          stopSlideshow();
        });

        _$("#leftRotate").on("click", () => {
          imagePreviewNew.rotateImage("left");
          stopSlideshow();
        });

        _$("#rightRotate").on("click", () => {
          imagePreviewNew.rotateImage("right");
          stopSlideshow();
        });
        break;
    }

    const nameBar = _$(`#${this.id} .name-bar`);
    nameBar.text(name);
  };

  openSlideShow = (id) => {
    this.init();
    _$("html").addClass("crushftp-opened-modal");

    this.slidesLength = this.slides.length;
    if (id) {
      const file = this.slides.find((file) => file.id === id);
      this.currentSlide = this.slides.indexOf(file);
    } else {
      this.currentSlide = 0;
    }

    if (!this.slides[this.currentSlide]) return;

    const sliderInfo = this.slides[this.currentSlide];

    this.renderPreview();
    this.displayFile(sliderInfo);

    window.addEventListener("keyup", this.keyUpHandler);
    window.addEventListener("keypress", this.keyPressHandler);
    _$("html").addClass("crushftp-opened-modal");
  };

  renderPreview = () => {
    const pre = _$(`#${this.id} .slideshow-footer .preview`);
    pre.html("");

    this.slides.forEach((file, index) => {
      const { href_path, preview } = file;

      const mediaPreview = _$("<div>").addClass("media-preview");
      pre.append(mediaPreview.el());
      mediaPreview.on("click", () => {
        this.goToSlide(index);
      });

      if (preview > 0) {
        const source = `/?command=getPreview&size=3&path=${encodeURIComponent(
          utils.decodeURILocal(href_path) || ""
        )}&frame=1&c2f=${utils.cookie.get("currentAuth")}`;

        const image = _$("<img>").el();
        image.src = source;
        mediaPreview.append(image);
      } else {
        const iconName = utils.isImageExtension(file) || "file";
        const icon = document.createElement("w-image");
        icon.className = "h-full";
        icon.setAttribute(
          "src",
          utils.hasAlternateWebInterfaceImagesPath()
            ? utils.getWebInterfaceImageUrl(
                `file-extension-icons/${iconName}-extension.png`
              )
            : `/WebInterface/new-ui/assets/images/file-extension-icons/${iconName}-extension.png`
        );
        icon.setAttribute("alt", "file-img");
        mediaPreview.append(icon);
      }
    });
  };

  updateSlides = ({ files }) => {
    this.slides = files;
  };

  createControlBar = (mediaType) => {
    const controlBar = _$(
      `#${this.id} .slideshow-footer .control-bar.info-bar`
    );

    const controlBarHTML = templates.controlBarTemplate({
      mediaType,
      playSlideshowText: t("playSlideshow"),
      pauseSlideshowText: t("pauseSlideshow"),
      slideShowStatus: this.slideInterval,
      slideShowDelayTime: this.slideDelay / 1000,
      isSlideShowFullScreen: this.isSlideShowFullScreen,
    });

    controlBar.html(controlBarHTML);

    const rightButton = _$("#right-angle").el();
    const leftButton = _$("#left-angle").el();

    rightButton.disabled = leftButton.disabled = this.slidesLength === 1;

    controlBar
      .find("[data-tooltip]")
      .sel()
      .forEach((button) => {
        this.tooltip.addTooltip({ element: button });
      });
  };

  zoomIn = (mediaDiv) => {
    if (mediaDiv.tagName === "IMG") {
      const image = mediaDiv;
      const height = image.clientHeight;
      // Round dynamic values to nearest 50px for utility class compatibility
      const roundedHeight = Math.round((height + 150) / 50) * 50;
      _$(image).css("height", `${roundedHeight}px`);
      _$(image).css("maxHeight", "none");
      _$(image).css("maxWidth", "none");
    }
  };

  zoomOut = (mediaDiv) => {
    if (mediaDiv.tagName === "IMG") {
      const image = mediaDiv;
      const height = image.clientHeight;
      // Round dynamic values to nearest 50px for utility class compatibility
      if (height - 150 > 100) {
        const roundedHeight = Math.round((height - 150) / 50) * 50;
        _$(image).css("height", `${roundedHeight}px`);
      }
    }
  };

  controlBarEvents = () => {
    const file = this.sliderInfo;

    _$("#delaySlider").on("input", (e) => {
      this.slideDelay = e.target.value * 1000;
      _$("#slideshowIntervalDelay").text(e.target.value);
      this.stopSlideshow(false);
      this.startSlideshow();
    });

    _$("#right-angle").on("click", () => {
      this.nextSlide();
      this.stopSlideshow();
    });

    _$("#left-angle").on("click", () => {
      this.prevSlide();
      this.stopSlideshow();
    });

    _$("#download-quick-view").on("click", () => {
      this.stopSlideshow();

      userActions.invoke({
        name: "download",
        curPath: file.href_path,
        loadedPath: file.root_dir,
        context: file,
      });
    });

    _$("#add-to-basket-quick-view").on("click", () => {
      this.stopSlideshow();
      const basketLengthBefore = this.filesAddedToBasket.size;
      this.filesAddedToBasket.add(file);

      const basketLengthAfter = this.filesAddedToBasket.size;

      if (basketLengthAfter === basketLengthBefore) return;

      growl("", t("fileAddedToBasket"), 5000);
    });

    _$("#edit-keywords-quick-view").on("click", () => {
      this.stopSlideshow();

      userActions.invoke({
        name: "updateKeywords",
        curPath: file.href_path,
        loadedPath: file.root_dir,
        context: file,
      });
    });

    _$("#refresh-slideshow").on("click", () => {
      this.closeSlider();

      userActions.invoke({
        name: "slideshow",
      });
    });

    _$("#play-or-pause-slideshow").on("click", () => {
      if (this.slideInterval) {
        this.stopSlideshow();
      } else {
        this.startSlideshow();
      }
    });

    _$("#delete-slide").on("click", () => {
      userActions.invoke({
        name: "delete",
        curPath: file.href_path,
        loadedPath: file.root_dir,
        context: file,
      });

      let currentSlide = this.currentSlide;

      userActions.invoke({
        name: "slideshow",
      });

      this.goToSlide(currentSlide);
    });

    _$("#fullscreen-slideshow").on("click", () => {
      this.toggleFullscreen();

      if (
        !document.fullscreenElement &&
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement &&
        !document.msFullscreenElement
      ) {
        _$("#fullscreen-slideshow").html(`<i class="icon-resize-small"></i>`);
        this.isSlideShowFullScreen = true;
      } else {
        _$("#fullscreen-slideshow").html(`<i class="icon-resize-full"></i>`);
        this.isSlideShowFullScreen = false;
      }
    });
  };

  closeSlider = () => {
    clearInterval(this.slideInterval);
    _$(`#${this.id} `).remove();
    _$("html").removeClass("crushftp-opened-modal");

    const filesAddedToBasket = Array.from(this.filesAddedToBasket);

    if (filesAddedToBasket.length > 0) {
      const { files: basketFiles } = store.basketDetails;

      const doesFileExists = (file) => {
        return basketFiles.find(
          (curFile) => curFile.href_path === file.href_path
        );
      };

      const filesToAdd = filesAddedToBasket.filter(
        (file) => !doesFileExists(file)
      );

      store.dispatch(
        "addFilesToBasket",
        filesToAdd.map((file) => ({
          ...file,
          isChecked: false,
          paddingLeft: null,
          ariaExpanded: false,
        }))
      );
      this.filesAddedToBasket = new Set([]);
    }
  };

  setMediaPlayerVolume = (media) => {
    const username = store?.userInfo?.username;
    if (!username) return;

    const volume = localStorage.getItem(`${username}_volume_level`);
    if (!volume) return;
    media.volume = parseFloat(volume);
  };

  storeMediaPlayerVolume = (media) => {
    if (this.storeMediaVolumeTimeoutId)
      clearTimeout(this.storeMediaVolumeTimeoutId);

    const username = store?.userInfo?.username;
    if (username) {
      this.storeMediaVolumeTimeoutId = setTimeout(() => {
        localStorage.setItem(`${username}_volume_level`, media.volume);
      }, 500);
    }

    _$("#audioSlider").el().value = media.volume;
  };

  toggleFullscreen = (elem) => {
    elem = elem || document.documentElement;
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      this.exitFullscreen();
    }
  };

  exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
  };

  startSlideshow = () => {
    this.slideInterval = setInterval(() => {
      if (this.mediaPlayed) {
        this.stopSlideshow(false);

        _$(this.media).on("ended", () => {
          this.nextSlide();
          this.startSlideshow();
        });

        return;
      }

      this.nextSlide();
    }, this.slideDelay);

    if (
      this.media.tagName === mediaTypes.AUDIO ||
      this.media.tagName === mediaTypes.VIDEO
    ) {
      this.media.play();
    }

    _$("#play-or-pause-slideshow i").el().className = "icon-pause";
    _$("#play-or-pause-slideshow span").text(t("pauseSlideshow"));
  };

  stopSlideshow = (shouldChangeSlideButton = true) => {
    clearInterval(this.slideInterval);

    if (!shouldChangeSlideButton) return;
    this.slideInterval = null;

    if (
      this.media.tagName === mediaTypes.AUDIO ||
      this.media.tagName === mediaTypes.VIDEO
    ) {
      this.media.pause();
    }

    _$("#play-or-pause-slideshow i").el().className = "icon-play";
    _$("#play-or-pause-slideshow span").text(t("playSlideshow"));
  };

  nextSlide = () => {
    this.goToSlide(this.currentSlide + 1);
  };

  prevSlide = () => {
    this.goToSlide(this.currentSlide - 1);
  };

  goToSlide = (n) => {
    this.currentSlide = (n + this.slides.length) % this.slides.length;
    this.displayFile(this.slides[this.currentSlide]);
  };

  keyUpHandler = (e) => {
    if (e.key === "ArrowRight") {
      this.nextSlide();
    } else if (e.key === "ArrowLeft") {
      this.prevSlide();
    } else if (e.key === "Escape") {
      this.closeSlider();
    }
  };

  keyPressHandler = (e) => {
    const mediaTag = this.media.tagName;

    if (e.key === "-") {
      this.zoomOut(mediaTag);
    } else if (e.key === "+") {
      this.zoomIn(mediaTag);
    }
  };
}
